<template>
    <SuperMillionContainer />
</template>

<script>
    import SuperMillionContainer from '@app/modules/sportCaller/superMillion/SuperMillionContainer';
    export default {
        name: 'SuperMillionPage',
        components: {
            SuperMillionContainer,
        },
    };
</script>
